import * as React from 'react'
import { useAuth } from '@/auth/AuthContext'
import { can } from '@/auth/access'
import { isVendor } from '@/auth/roles'
import { cn } from '@/lib/utils'
import { VendorProfileSheet, type ProfileContext } from '@/components/VendorProfileSheet'
import { possessive } from '@lib/helpers/format'

interface Props {
  vendorId: string
  name: string
  className?: string
  /** Where the profile is opened from, for what the sheet offers there. */
  context?: ProfileContext | undefined
}

/**
 * A vendor company's name that opens its profile, for whoever may read one
 * (docs/vendor-growth.spec.md): venue staff who can view vendors, planners,
 * and couples, who read the profiles of their venue's vendors and of those on
 * their events. Anyone else sees the name as text.
 */
export function VendorProfileLink({ vendorId, name, className, context }: Props) {
  const { user } = useAuth()
  const [open, setOpen] = React.useState(false)
  if (!isVendor(user) && user?.role !== 'CLIENT' && !can(user, 'vendors:view')) return <span className={className}>{name}</span>
  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className={cn('text-left underline decoration-line-strong underline-offset-2 hover:decoration-ink', className)}
        aria-label={`View ${possessive(name)} profile`}
      >
        {name}
      </button>
      <VendorProfileSheet vendorId={open ? vendorId : null} name={name} onClose={() => setOpen(false)} context={context} />
    </>
  )
}
